import Cropper, { type Area } from 'react-easy-crop';

export type ImageCropperPoint = {
  x: number;
  y: number;
};

export type ImageCropperArea = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type ImageCropperProps = {
  image: string;
  crop: ImageCropperPoint;
  zoom: number;
  aspect?: number;
  cropShape?: 'rect' | 'round';
  showGrid?: boolean;
  onCropChange: (crop: ImageCropperPoint) => void;
  onZoomChange: (zoom: number) => void;
  onCropComplete?: (area: ImageCropperArea, croppedAreaPixels: ImageCropperArea) => void;
};

const toArea = (area: Area): ImageCropperArea => ({
  x: area.x,
  y: area.y,
  width: area.width,
  height: area.height,
});

export function ImageCropper({
  image,
  crop,
  zoom,
  aspect = 1,
  cropShape = 'round',
  showGrid = false,
  onCropChange,
  onZoomChange,
  onCropComplete,
}: ImageCropperProps) {
  return (
    <Cropper
      image={image}
      crop={crop}
      zoom={zoom}
      aspect={aspect}
      cropShape={cropShape}
      showGrid={showGrid}
      onCropChange={onCropChange}
      onZoomChange={onZoomChange}
      onCropComplete={(area, croppedAreaPixels) =>
        onCropComplete?.(toArea(area), toArea(croppedAreaPixels))
      }
    />
  );
}
